<template>
  <v-wait :for="loaderId">
    <template slot="waiting">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <half-circle-spinner />
        </b-col>
      </b-row>
    </template>
    <template>
      <b-row class="mb-3">
        <b-col lg="12">
          <div
            class="font-weight-bold v3_color_teal border_bottom_1 border_bottom_light_teal pb-2 font_size_1000rem"
          >
            Demographics
          </div>
        </b-col>
      </b-row>
      <p v-if="specialtiesStatistics">
        <span
          v-if="specialtiesStatistics.specialty_users"
          class="d-inline-flex align-items-center font_size_1000rem"
        >
          <strong>{{ specialtiesStatistics.specialty_users }}</strong>
          <span class="ml-1 separator">
            Physicians In Your Specialty
          </span>
        </span>
        <span
          v-if="specialtiesStatistics.subspecialties"
          class="d-inline-flex align-items-center font_size_1000rem ml-3 small-mobile-screens"
        >
          <strong>{{ specialtiesStatistics.subspecialties }}</strong>
          <span class="ml-1 separator">
            Subspecialties
          </span>
        </span>
        <span
          v-if="specialtiesStatistics.subspecialty_users"
          class="d-inline-flex align-items-center font_size_1000rem ml-3 small-mobile-screens"
        >
          <strong>{{ specialtiesStatistics.subspecialty_users }}</strong>
          <span class="ml-1">
            Physicians In Your Subspecialty
          </span>
        </span>
      </p>
      <div class="box-body-wrapper">
        <b-row class="w-100">
          <b-col xl="2" lg="6" md="6" sm="12">
            <info-donut-with-legend
              v-if="profileDataStatistic && profileDataStatistic.gender"
              :chart-data="profileDataStatistic.gender"
              chartTitle="Gender"
            />
          </b-col>
          <b-col xl="2" lg="6" md="6" sm="12">
            <info-donut-with-legend
              v-if="profileDataStatistic && profileDataStatistic.age"
              :chart-data="profileDataStatistic.age"
              chartTitle="Age (Years)"
            />
          </b-col>
          <b-col xl="2" lg="6" md="6" sm="12">
            <info-donut-with-legend
              v-if="profileDataStatistic && profileDataStatistic.race"
              :chart-data="profileDataStatistic.race"
              chartTitle="Race"
            />
          </b-col>
          <b-col xl="6" lg="12" md="12">
            <usa-map-chart
              v-if="locationStatistics"
              :chart-data="locationStatistics"
              :chart-title="mapTitle"
            />
          </b-col>
        </b-row>
      </div>
    </template>
  </v-wait>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import InfoDonutWithLegend from '@/components/dashboard/metrics/components/InfoDonutWithLegendV3';
import UsaMapChart from '@/components/dashboard/metrics/components/UsaMapChartV3';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';

export default {
  name: 'Demographic',
  components: {
    HalfCircleSpinner,
    InfoDonutWithLegend,
    UsaMapChart,
  },
  data: function () {
    return {
      specialtiesStatistics: null,
      profileDataStatistic: null,
      locationStatistics: null,
    };
  },
  created: function () {
    this.getStatistics();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    mapTitle: function () {
      return `Physician Location`;
    },
  },
  methods: {
    getStatistics: async function () {
      this.$wait.start(this.loaderId);
      try {
        const getStatisticFunctions = [
            await Api.getSpecialtiesStatistics(),
            await Api.getProfileDataStatistic(),
            await Api.getLocationStatistic(),
          ];
        const fetchResults = await Promise.allSettled(getStatisticFunctions);
        if (fetchResults[0] && fetchResults[0].status === 'fulfilled')
          this.specialtiesStatistics = fetchResults[0].value;
        else
          this.$toasted.error('Unable to upload specialties statistics.', {
            duration: 3000,
          });
        if (fetchResults[1] && fetchResults[1].status === 'fulfilled')
          this.profileDataStatistic = fetchResults[1].value;
        else
          this.$toasted.error('Unable to upload profile data statistics.', {
            duration: 3000,
          });
        if (fetchResults[2] && fetchResults[2].status === 'fulfilled')
          this.locationStatistics = fetchResults[2].value;
        else
          this.$toasted.error('Unable to upload location data statistics.', {
            duration: 3000,
          });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style>
@media (max-width:485px){
  .small-mobile-screens{
    margin: unset !important;
  }
  .box-body-wrapper{
    padding: 0.7rem !important;
  }
  .box-body-wrapper .w-100{
    width: unset;
  }
  .card-body{
    padding: 5px 0 !important;
  }
}
.separator {
  border-right: 1px solid #00586f;
  padding-right: 10px;
}
</style>
